export const needHelpIconClick = {
    event: "new_menu",
    eventAction: "need_help | click"
};
